'use strict';
import React,{ Component } from 'react';
import { connect } from 'react-redux';
import { setRawDataFilter } from '../../action/index';
import { bindActionCreators } from 'redux';


class QueryBuildComponent extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            rules_basic:[{empty:true}]
        }


        // this.handleDataFormat = this.handleDataFormat.bind(this);
        // this.getRules = this.getRules.bind(this);
    }

    
    componentDidMount(){
        var rules_basic = this.state.rules_basic
        if(this.props.rules_basic !== null && this.props.rules_basic.tableName==this.props.tableName){
            rules_basic = this.props.rules_basic !== null ?this.props.rules_basic:this.state.rules_basic
        }

        let filters = this.handleDataFormat();

        jQuery('#builder-basic').queryBuilder({
            // plugins: ['bt-tooltip-errors'],

            filters:filters,
            rules:rules_basic
        });
    }

   componentDidUpdate(prevProps, nextState) {
        let rules = this.state.rules_basic;
       if (this.props.rules_basic !== null && this.props.rules_basic.tableName==this.props.tableName){
            rules = this.props.rules_basic !== null ?this.props.rules_basic:this.state.rules_basic;
        }

        if(rules !== null && rules !== undefined){
            jQuery('#builder-basic').queryBuilder('setRules', rules);
        }
    }

    handleDataFormat(){
        
        let data = this.props.filters;
        let filterData = Object.keys(data[0]).map((element,i)=>{
            let innerArray = {};
            innerArray['id'] = element;
            innerArray['label'] = element;
            innerArray['type'] = 'string';
            return innerArray;
        });
        return filterData;
    }

    getRules(){
        // gets the result of the filters in json
        var rules_basic = jQuery('#builder-basic').queryBuilder('getRules');

        rules_basic['tableName']=this.props.tableName;

        // gets the result of the filters applied in a sql query
        var result = jQuery('#builder-basic').queryBuilder('getSQL');
        this.props.setRawDataFilter(rules_basic);
        this.props.fetchHandle(result['sql']);
        
        // console.log(result);

        // if (!jQuery.isEmptyObject(result)) {
        //     alert(JSON.stringify(result, null, 2));
        // }
    }

    render(){

        return (
            <>
                <div  id="builder-basic"></div>
                <button onClick={this.getRules} className="btn btn-sm btn-primary">Apply</button>
            </>
        )
    }
}

export default QueryBuildComponent;